import { EventCategory, EventStatus } from '../types';

export const getCategoryLabel = (category: EventCategory): string => {
  const labels: Record<EventCategory, string> = {
    LITURGY: 'Богослужение',
    MEETING: 'Встреча',
    FEAST: 'Праздник',
    EDUCATION: 'Образовательное',
    CHARITY: 'Благотворительность',
    OTHER: 'Другое',
  };
  return labels[category] || category;
};

export const getStatusLabel = (status: EventStatus): string => {
  const labels: Record<EventStatus, string> = {
    DRAFT: 'Черновик',
    PUBLISHED: 'Опубликовано',
    ARCHIVED: 'Архив',
  };
  return labels[status] || status;
};

export const getStatusColor = (status: EventStatus): 'default' | 'success' | 'warning' | 'error' => {
  const colors: Record<EventStatus, 'default' | 'success' | 'warning' | 'error'> = {
    DRAFT: 'warning',
    PUBLISHED: 'success',
    ARCHIVED: 'error',
  };
  return colors[status];
};

export const getCategoryColor = (category: EventCategory): 'default' | 'primary' | 'secondary' | 'info' => {
  const colors: Record<EventCategory, 'default' | 'primary' | 'secondary' | 'info'> = {
    LITURGY: 'primary',
    MEETING: 'secondary',
    FEAST: 'info',
    EDUCATION: 'info',
    CHARITY: 'info',
    OTHER: 'default',
  };
  return colors[category];
};